.navLogo {
	display: flex;
	justify-content: center;
	width: 100%;
	background-color: #163342;
}
